"use client";
import {
	AcademicCapIcon,
	AdjustmentsHorizontalIcon,
	ArrowDownIcon,
	ArrowDownTrayIcon,
	ArrowLeftIcon,
	ArrowPathIcon,
	ArrowRightEndOnRectangleIcon,
	ArrowRightIcon,
	ArrowUpIcon,
	ArrowUpTrayIcon,
	ArrowUturnLeftIcon,
	AtSymbolIcon,
	Bars4Icon,
	BeakerIcon,
	BellAlertIcon,
	BugAntIcon,
	CalendarIcon,
	ChatBubbleBottomCenterTextIcon,
	ChatBubbleOvalLeftIcon,
	ChevronDownIcon,
	ChevronLeftIcon,
	ChevronRightIcon,
	ChevronUpIcon,
	ClipboardDocumentListIcon,
	ClipboardIcon,
	ClockIcon,
	CloudArrowDownIcon,
	CloudArrowUpIcon,
	CodeBracketIcon,
	Cog6ToothIcon,
	CommandLineIcon,
	CpuChipIcon,
	CubeIcon,
	DocumentCheckIcon,
	DocumentIcon,
	EllipsisHorizontalCircleIcon,
	EllipsisHorizontalIcon,
	EllipsisVerticalIcon,
	EnvelopeIcon,
	EnvelopeOpenIcon,
	ExclamationCircleIcon,
	ExclamationTriangleIcon,
	FaceSmileIcon,
	FingerPrintIcon,
	FunnelIcon,
	GiftIcon,
	GlobeAltIcon,
	HandThumbUpIcon,
	InboxStackIcon,
	InformationCircleIcon,
	LifebuoyIcon,
	LinkIcon,
	MagnifyingGlassIcon,
	MapPinIcon,
	MoonIcon,
	NewspaperIcon,
	NoSymbolIcon,
	PaperAirplaneIcon,
	PaperClipIcon,
	PencilSquareIcon,
	PhoneIcon,
	PlusCircleIcon as PlusCircleOutlineIcon,
	PuzzlePieceIcon,
	RocketLaunchIcon,
	SpeakerWaveIcon,
	SpeakerXMarkIcon,
	Square2StackIcon,
	StarIcon,
	SunIcon,
	SwatchIcon,
	TagIcon,
	TrashIcon,
	TrophyIcon,
	TvIcon,
	UserIcon,
	UserPlusIcon,
	UsersIcon,
	VideoCameraIcon,
	VideoCameraSlashIcon,
	WalletIcon,
	WrenchScrewdriverIcon,
	XMarkIcon,
} from "@heroicons/react/24/outline";
import {
	BoltIcon,
	BookOpenIcon,
	ChatBubbleLeftRightIcon,
	CheckBadgeIcon,
	CheckCircleIcon,
	Cog8ToothIcon,
	DocumentTextIcon,
	EyeIcon,
	EyeSlashIcon,
	InboxIcon,
	LightBulbIcon,
	LockClosedIcon,
	PencilIcon,
	PlayCircleIcon,
	PlusCircleIcon,
	ShieldCheckIcon,
	ClockIcon as SolidClockIcon,
	IdentificationIcon as SolidIdentificationIcon,
	PaperAirplaneIcon as SolidPaperAirplaneIcon,
	UsersIcon as SolidUsersIcon,
	VideoCameraIcon as SolidVideoCameraIcon,
	SparklesIcon,
	Square2StackIcon as SquareFilledIcon,
	Squares2X2Icon,
} from "@heroicons/react/24/solid";
import {
	ArrowBendUpLeft,
	ArrowBendUpRight,
	ArrowsInLineHorizontal,
	ArrowsInLineVertical,
	ArrowsInSimple,
	ArrowsOutLineHorizontal,
	ArrowsOutLineVertical,
	ArrowsOutSimple,
	Bell,
	Brain,
	Briefcase,
	CaretUpDown,
	ChatTeardropText,
	CircleNotch,
	ClipboardText,
	CreditCard,
	DotsSixVertical,
	FolderOpen,
	List,
	ListBullets,
	ListNumbers,
	MagnifyingGlassMinus,
	MagnifyingGlassPlus,
	PenNib,
	Plus,
	Sidebar,
	SmileyWink,
	StopCircle,
	TextAUnderline,
	TextAlignCenter,
	TextAlignJustify,
	TextAlignLeft,
	TextAlignRight,
	TextBolder,
	TextItalic,
	TextUnderline,
	XCircle,
} from "@phosphor-icons/react";
import { type VariantProps, cva } from "class-variance-authority";
import { Check, CheckCheckIcon, PenIcon } from "lucide-react";
import type { SVGProps } from "react";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import AsanaIcon from "./icons/asana.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import AtlassianIcon from "./icons/atlassian.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import CcpaIcon from "./icons/ccpa.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import ChromeIcon from "./icons/chrome.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import CloudflareIcon from "./icons/cloudflare.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import DeepwikiIcon from "./icons/deepwiki.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import ForwardIcon from "./icons/forward.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import GdprIcon from "./icons/gdpr.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import GmailStandaloneIcon from "./icons/gmail-standalone.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import GmailIcon from "./icons/gmail.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import GoogleDriveIcon from "./icons/google-drive.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import GoogleIcon from "./icons/google.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import Google2Icon from "./icons/google2.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import HipaaIcon from "./icons/hipaa.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import HubspotIcon from "./icons/hubspot.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import IntercomIcon from "./icons/intercom.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import Iso27001Icon from "./icons/iso27001.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import JaceIcon from "./icons/jace.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import LinearIcon from "./icons/linear.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import NeonIcon from "./icons/neon.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import NotionIcon from "./icons/notion.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import OutlookIcon from "./icons/outlook.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import PaypalIcon from "./icons/paypal.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import PosthogIcon from "./icons/posthog.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import ReplyIcon from "./icons/reply.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import SentryIcon from "./icons/sentry.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import ShopifyIcon from "./icons/shopify.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import SlackColorIcon from "./icons/slack-color.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import Soc2Icon from "./icons/soc2.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import SquareIcon from "./icons/square.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import StripeIcon from "./icons/stripe.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import TiktokIcon from "./icons/tiktok-logo.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import TwilioIcon from "./icons/twilio.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import TwitterVerifiedIcon from "./icons/twitter-verified.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import WebflowIcon from "./icons/webflow.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import WixIcon from "./icons/wix.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import XLogo from "./icons/x-logo.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import ZapierIcon from "./icons/zapier.svg";
// @ts-ignore TODO: For some reason TS doesn't see ./types/svg.d.ts, debug later
import { cn } from "./lib/utils";

function DiscordIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z" />
		</svg>
	);
}

function XIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M13.6823 10.6218L20.2391 3H18.6854L12.9921 9.61788L8.44486 3H3.2002L10.0765 13.0074L3.2002 21H4.75404L10.7663 14.0113L15.5685 21H20.8131L13.6819 10.6218H13.6823ZM11.5541 13.0956L10.8574 12.0991L5.31391 4.16971H7.70053L12.1742 10.5689L12.8709 11.5655L18.6861 19.8835H16.2995L11.5541 13.096V13.0956Z" />
		</svg>
	);
}

function LinkedInIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
		</svg>
	);
}

function FacebookIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path
				fillRule="evenodd"
				d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

function InstagramIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path
				fillRule="evenodd"
				d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

function GitHubIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path
				fillRule="evenodd"
				d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

function YouTubeIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path
				fillRule="evenodd"
				d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z"
				clipRule="evenodd"
			/>
		</svg>
	);
}

function SlackIcon(props: Omit<IconProps, "kind">) {
	return (
		<svg viewBox="0 0 24 24" fill="currentColor" {...props}>
			<path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zM6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313zM8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zM8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312zM18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zM17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312zM15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52zM15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" />
		</svg>
	);
}

export const supportedIcons = {
	ai: SparklesIcon,
	discord: DiscordIcon,
	gift: GiftIcon,
	linkedin: LinkedInIcon,
	twitter: XIcon,
	tiktok: TiktokIcon,
	google: GoogleIcon,
	"google-white": Google2Icon,
	outlook: OutlookIcon,
	gmail: GmailIcon,
	jace: JaceIcon,
	x: XLogo,
	"twitter-verified": TwitterVerifiedIcon,
	gdpr: GdprIcon,
	hipaa: HipaaIcon,
	iso27001: Iso27001Icon,
	soc2: Soc2Icon,
	ccpa: CcpaIcon,
	facebook: FacebookIcon,
	instagram: InstagramIcon,
	notion: NotionIcon,
	googleDrive: GoogleDriveIcon,
	github: GitHubIcon,
	youtube: YouTubeIcon,
	slack: SlackIcon,
	"slack-color": SlackColorIcon,
	play: PlayCircleIcon,
	reply: ReplyIcon,
	forward: ForwardIcon,
	usersSolid: SolidUsersIcon,
	shield: ShieldCheckIcon,
	agendaSolid: DocumentTextIcon,
	timeSolid: SolidClockIcon,
	filter: FunnelIcon,
	"ai-beaker": BeakerIcon,
	"ai-brain": CpuChipIcon,
	"ai-book": BookOpenIcon,
	"ai-command": CommandLineIcon,
	"ai-idea": LightBulbIcon,
	"ai-rocket": RocketLaunchIcon,
	"clipboard-text": ClipboardText,
	newspaper: NewspaperIcon,
	"grip-vertical": DotsSixVertical,
	add: Plus,
	jaceChat: ChatTeardropText,
	"add-circle": PlusCircleIcon,
	"add-circle-outline": PlusCircleOutlineIcon,
	"person-add": UserPlusIcon,
	delete: TrashIcon,
	"up-down": CaretUpDown,
	"credit-card": CreditCard,
	download: ArrowDownTrayIcon,
	upload: ArrowUpTrayIcon,
	"cloud-upload": CloudArrowUpIcon,
	"cloud-download": CloudArrowDownIcon,
	"file-editor": PencilSquareIcon,
	terminal: CommandLineIcon, // TODO: find a better one
	"tool-manager": CubeIcon,
	"puzzle-piece": PuzzlePieceIcon,
	error: ExclamationCircleIcon,
	done: Check,
	"check-check": CheckCheckIcon,
	"done-filled": CheckCircleIcon,
	web: GlobeAltIcon,
	bolt: BoltIcon,
	brain: Brain,
	tool: WrenchScrewdriverIcon,
	help: LifebuoyIcon,
	feedback: PaperAirplaneIcon,
	expand: ChevronDownIcon,
	collapse: ChevronUpIcon,
	"chevron-right": ChevronRightIcon,
	"chevron-left": ChevronLeftIcon,
	copy: ClipboardIcon,
	close: XMarkIcon,
	"arrow-left": ArrowLeftIcon,
	"arrow-right": ArrowRightIcon,
	"arrow-up": ArrowUpIcon,
	"arrow-down": ArrowDownIcon,
	"arrow-bend-up-right": ArrowBendUpRight,
	"arrow-bend-up-left": ArrowBendUpLeft,
	logout: ArrowRightEndOnRectangleIcon,
	search: MagnifyingGlassIcon,
	more: EllipsisHorizontalCircleIcon,
	email: AtSymbolIcon,
	unread: EnvelopeOpenIcon,
	read: EnvelopeIcon,
	code: CodeBracketIcon,
	warning: ExclamationCircleIcon,
	calendar: CalendarIcon,
	time: ClockIcon,
	location: MapPinIcon,
	stop: NoSymbolIcon,
	"stop-circle": StopCircle,
	edit: PencilIcon,
	"document-check": DocumentCheckIcon,
	live: TvIcon,
	burger: Bars4Icon,
	eye: EyeIcon,
	"eye-slash": EyeSlashIcon,
	list: List,
	bell: Bell,
	sidebar: Sidebar,
	details: EllipsisVerticalIcon,
	cancel: XCircle,
	swatch: SwatchIcon,
	"squares-2x2": Squares2X2Icon,
	wallet: WalletIcon,
	badge: CheckBadgeIcon,
	chat: ChatBubbleLeftRightIcon,
	inbox: InboxIcon,
	fold: ArrowsInLineVertical,
	unfold: ArrowsOutLineVertical,
	shorten: ArrowsInLineHorizontal,
	lengthen: ArrowsOutLineHorizontal,
	sync: ArrowPathIcon,
	// Zoom controls
	"zoom-in": MagnifyingGlassPlus,
	"zoom-out": MagnifyingGlassMinus,
	// Formatting
	bold: TextBolder,
	italic: TextItalic,
	underline: TextUnderline,
	"settings-outline": Cog6ToothIcon,
	settings: Cog8ToothIcon,
	link: LinkIcon,
	detach: ArrowRightEndOnRectangleIcon,
	star: StarIcon,
	user: UserIcon,
	users: UsersIcon,
	document: DocumentIcon,
	"document-text": DocumentTextIcon,
	tag: TagIcon,
	info: InformationCircleIcon,
	spam: ExclamationTriangleIcon,
	adjustments: AdjustmentsHorizontalIcon,
	send: PaperAirplaneIcon,
	"send-fill": SolidPaperAirplaneIcon,
	lightMode: SunIcon,
	darkMode: MoonIcon,
	back: ArrowUturnLeftIcon,
	mute: SpeakerXMarkIcon,
	unmute: SpeakerWaveIcon,
	microphone: PhoneIcon,
	videoCamera: VideoCameraIcon,
	videoCameraSolid: SolidVideoCameraIcon,
	noVideoCamera: VideoCameraSlashIcon,
	formal: Briefcase,
	casual: SmileyWink,
	morePlain: EllipsisHorizontalIcon,
	"finger-print": FingerPrintIcon,
	signature: PenNib,
	paperclip: PaperClipIcon,
	"users-search": UsersIcon,
	"folder-open": FolderOpen,
	"checkbox-empty": Square2StackIcon,
	"checkbox-filled": SquareFilledIcon,
	person: UserIcon,
	messages: ChatBubbleLeftRightIcon,
	spinner: CircleNotch,
	locked: LockClosedIcon,
	bug: BugAntIcon,
	idea: LightBulbIcon,
	"bulleted-list": ListBullets,
	"numbered-list": ListNumbers,
	"text-left": TextAlignLeft,
	"text-right": TextAlignRight,
	"text-center": TextAlignCenter,
	"text-justify": TextAlignJustify,
	"inbox-stack": InboxStackIcon,
	bot: SolidIdentificationIcon,
	"todo-list": ClipboardDocumentListIcon,
	"todo-trophy": TrophyIcon,
	"todo-approve": HandThumbUpIcon,
	"academic-cap": AcademicCapIcon,
	"reply-message": ChatBubbleOvalLeftIcon,
	"reply-chat": ChatBubbleBottomCenterTextIcon,
	"reply-phone": PhoneIcon,
	"reply-mail": EnvelopeOpenIcon,
	"reply-alert": BellAlertIcon,
	chrome: ChromeIcon,
	"gmail-standalone": GmailStandaloneIcon,
	linear: LinearIcon,
	asana: AsanaIcon,
	cloudflare: CloudflareIcon,
	hubspot: HubspotIcon,
	intercom: IntercomIcon,
	paypal: PaypalIcon,
	posthog: PosthogIcon,
	shopify: ShopifyIcon,
	stripe: StripeIcon,
	twilio: TwilioIcon,
	zapier: ZapierIcon,
	atlassian: AtlassianIcon,
	sentry: SentryIcon,
	deepwiki: DeepwikiIcon,
	webflow: WebflowIcon,
	wix: WixIcon,
	square: SquareIcon,
	neon: NeonIcon,
	minimize: ArrowsInSimple,
	maximize: ArrowsOutSimple,
	"text-formatting": TextAUnderline,
} as const;

export interface IconSVGProps extends SVGProps<SVGSVGElement> {
	className?: string;
	onClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
}
export type IconKind = keyof typeof supportedIcons;

const iconVariants = cva(
	"inline-block flex-grow-0 flex-shrink-0 text-inherit",
	{
		variants: {
			size: {
				min: "w-icon-min h-icon-min",
				xs: "w-icon-xs h-icon-xs",
				sm: "w-icon-sm h-icon-sm",
				md: "w-icon-md h-icon-md",
				lg: "w-icon-lg h-icon-lg",
			},
		},
		defaultVariants: {
			size: "md",
		},
	},
);

export interface IconProps extends VariantProps<typeof iconVariants> {
	kind: IconKind;
	weight?: "fill" | "regular";
	className?: string;
	onClick?: (e: React.MouseEvent<SVGSVGElement>) => void;
}

export function Icon({
	kind,
	className,
	size,
	weight,
	onClick,
	...props
}: IconProps): React.ReactElement {
	const IconComponent = supportedIcons[kind];

	return (
		<IconComponent
			className={cn(iconVariants({ size, className }), className)}
			weight={weight}
			onClick={onClick}
			{...props}
		/>
	);
}

export function CheckIcon({
	className,
	...props
}: IconSVGProps): React.ReactElement {
	return <Icon className={className} kind="done" {...props} />;
}

// Map company names to their corresponding icon kinds
export function getCompanyIcon(companyName: string): IconKind | null {
	const normalizedName = companyName.toLowerCase();

	const companyIconMap: Record<string, IconKind> = {
		linear: "linear",
		asana: "asana",
		cloudflare: "cloudflare",
		hubspot: "hubspot",
		intercom: "intercom",
		paypal: "paypal",
		posthog: "posthog",
		shopify: "shopify",
		stripe: "stripe",
		twilio: "twilio",
		zapier: "zapier",
		atlassian: "atlassian",
		jira: "atlassian",
		confluence: "atlassian",
		sentry: "sentry",
		slack: "slack",
		github: "github",
		google: "google",
		"google drive": "googleDrive",
		gdrive: "googleDrive",
		notion: "notion",
	};

	return companyIconMap[normalizedName] || null;
}
